var _path, _path2, _line, _line2, _line3, _line4, _path3, _path4, _line5, _path5, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFoldersorFiles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 229,
    viewBox: "0 0 227 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 77V69C13.0001 62.3726 18.3727 57 25.0001 57H179C185.628 57 191 62.3726 191 69V99M198.783 206.84L205.099 116.84C205.586 109.899 200.087 104 193.129 104H143.971C140.788 104 137.736 102.736 135.485 100.485L115.741 80.7406C113.358 78.3575 110.082 77.0864 106.715 77.238L13.5148 81.4363C6.69188 81.7436 1.5009 87.6755 2.1012 94.4789L12.0344 207.055C12.5809 213.249 17.7693 218 23.9879 218H186.813C193.114 218 198.342 213.126 198.783 206.84Z",
    stroke: "#EE6517",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0001 174.882C99.0078 151.555 112.451 155.972 135.008 174.882",
    stroke: "#F4501C",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 52.5301,
    y1: 117.152,
    x2: 76.5301,
    y2: 132.152,
    stroke: "#F4501C",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 28.3019,
    y2: -1,
    transform: "matrix(-0.847998 0.529999 0.529999 0.847998 76.0001 118)",
    stroke: "#F4501C",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 135.53,
    y1: 117.152,
    x2: 159.53,
    y2: 132.152,
    stroke: "#F4501C",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 28.3019,
    y2: -1,
    transform: "matrix(-0.847998 0.529999 0.529999 0.847998 159 118)",
    stroke: "#F4501C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21301 102C3.21301 102 -0.786937 221.512 4.21301 224",
    stroke: "#F4501C",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00012 222.5C95.0611 224.446 139.955 226.012 226.014 226",
    stroke: "#F4501C",
    strokeWidth: 6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 201,
    y1: 218,
    x2: 223,
    y2: 218,
    stroke: "#F4501C",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.726 30C216.26 47.25 215.527 51 211.863 60C208.932 51 208.199 47.25 206 30C206 13.4315 206 0 211.863 0C219.925 0 217.726 13.4315 217.726 30Z",
    fill: "#FB7C51"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.5,
    cy: 71,
    rx: 5.5,
    ry: 8,
    fill: "#FB7C51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFoldersorFiles);
export default __webpack_public_path__ + "static/media/noFoldersorFiles.6ef263ad9450384aecc200043455aed3.svg";
export { ForwardRef as ReactComponent };